import { groq } from 'next-sanity'

export const AccordionQuery = groq`
  _type == "accordion" => {...,}
`
